import { defineCustomElement } from "vue";

import OperationLog from "./operationLog.ce.vue";

const CustomElement = defineCustomElement(OperationLog);

// 为了便于业务自定义标签名称，导出名称注册方法，默认为operation-log
export function operationLogRegister(tagName: string = "operation-log") {
  customElements.define(tagName, CustomElement);
  return CustomElement;
}
